import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation
} from "react-router-dom";

import {
  lazy,
  Suspense,
  useState,
  useEffect
} from "react";

import CustomOrderPage
  from "./pages/CustomOrderPage";

import {
  AnimatePresence
} from "framer-motion";

import Navbar
  from "./components/Navbar";

import Footer
  from "./components/Footer";

import WhatsAppButton
  from "./components/WhatsAppButton";

import SalesPopup
  from "./components/SalesPopup";

import MobileBottomNav
  from "./components/MobileBottomNav";

import AdminRoute
  from "./components/AdminRoute";

import PageTransition
  from "./components/PageTransition";

import LuxuryLoader
  from "./components/LuxuryLoader";

import ProtectedRoute
  from "./components/ProtectedRoute";

import AuthModal
  from "./components/AuthModal";

import {
  CartProvider
} from "./context/CartContext";

import {
  AuthProvider
} from "./context/AuthContext";

import {
  WishlistProvider
} from "./context/WishlistContext";

import {
  HelmetProvider
} from "react-helmet-async";

import {
  AuthModalProvider
} from "./context/AuthModalContext";

import CollectionProducts
  from "./pages/CollectionProducts";

import AccountPage
  from "./pages/AccountPage";

import SupportPage
  from "./pages/SupportPage";

import FeedbackPage
  from "./pages/FeedbackPage";

import OrderTracking
  from "./pages/OrderTracking";

import OrdersPage
  from "./pages/OrdersPage";

import AddressPage
  from "./pages/AddressPage";

/* ===============================
   LAZY PAGES
=============================== */

const Home =
  lazy(() =>
    import("./pages/Home")
  );

const ProductList =
  lazy(() =>
    import("./pages/ProductList")
  );

const ProductDetails =
  lazy(() =>
    import("./pages/ProductDetails")
  );

const CheckoutPage =
  lazy(() =>
    import("./pages/CheckoutPage")
  );

const OrderSuccess =
  lazy(() =>
    import("./pages/OrderSuccess")
  );



const AdminDashboard =
  lazy(() =>
    import("./pages/AdminDashboard")
  );

const AdminLogin =
  lazy(() =>
    import("./pages/AdminLogin")
  );

const AdminOrders =
  lazy(() =>
    import("./pages/AdminOrders")
  );

const Recommendations =
  lazy(() =>
    import("./pages/Recommendations")
  );

const Login =
  lazy(() =>
    import("./pages/Login")
  );

const Register =
  lazy(() =>
    import("./pages/Register")
  );

const Wishlist =
  lazy(() =>
    import("./pages/WishlistPage")
  );

const Cart =
  lazy(() =>
    import("./pages/CartPage")
  );
  const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
  const ResetPassword  = lazy(() => import("./pages/ResetPassword"));

/* ===============================
   ROUTES
=============================== */

function AnimatedRoutes() {

  const location =
    useLocation();

  return (

    <AnimatePresence mode="wait">

      <Routes location={location}>

        {/* HOME */}

        <Route
          path="/"
          element={
            <PageTransition>
              <Home />
            </PageTransition>
          }
        />

        {/* PRODUCTS */}

        <Route
          path="/products"
          element={
            <PageTransition>
              <ProductList />
            </PageTransition>
          }
        />

        <Route
          path="/product/:id"
          element={
            <PageTransition>
              <ProductDetails />
            </PageTransition>
          }
        />

        <Route
          path="/collections/:slug"
          element={
            <PageTransition>
            <CollectionProducts />
            </PageTransition>
          }
        />

        {/* CART */}

        <Route
          path="/cart"
          element={
            <ProtectedRoute>
              <PageTransition>
                <Cart />
              </PageTransition>
            </ProtectedRoute>
          }
        />

        <Route
          path="/wishlist"
          element={
            <ProtectedRoute>
              <PageTransition>
                <Wishlist />
              </PageTransition>
            </ProtectedRoute>
          }
        />

        <Route
          path="/checkout"
          element={
            <ProtectedRoute>
              <PageTransition>
                <CheckoutPage />
              </PageTransition>
            </ProtectedRoute>
          }
        />

        {/* AUTH */}

        <Route
          path="/login"
          element={
            <PageTransition>
              <Login />
            </PageTransition>
          }
        />

        <Route
          path="/register"
          element={
            <PageTransition>
              <Register />
            </PageTransition>
          }
        />
          {/* PASSWORD RESET */}

                <Route
                  path="/forgot-password"
                  element={
                    <PageTransition>
                      <ForgotPassword />
                    </PageTransition>
                  }
                />

                <Route
                  path="/reset-password"
                  element={
                    <PageTransition>
                      <ResetPassword />
                    </PageTransition>
                  }
                />

        {/* ORDERS */}

        <Route
          path="/order-success"
          element={
            <PageTransition>
              <OrderSuccess />
            </PageTransition>
          }
        />

        <Route
          path="/my-orders"
          element={
            <ProtectedRoute>
              <PageTransition>
                <OrdersPage />
              </PageTransition>
            </ProtectedRoute>
          }
        />

        <Route
          path="/orders"
          element={
            <ProtectedRoute>
              <PageTransition>
                <OrdersPage />
              </PageTransition>
            </ProtectedRoute>
          }
        />

        {/* USER */}

        <Route
          path="/account"
          element={
            <ProtectedRoute>
              <PageTransition>
                <AccountPage />
              </PageTransition>
            </ProtectedRoute>
          }
        />

        <Route
          path="/addresses"
          element={
            <PageTransition>
              <AddressPage />
            </PageTransition>
          }
        />

        <Route
          path="/support"
          element={
            <PageTransition>
              <SupportPage />
            </PageTransition>
          }
        />

        <Route
          path="/feedback"
          element={
            <PageTransition>
              <FeedbackPage />
            </PageTransition>
          }
        />

        <Route
          path="/track-order"
          element={
            <PageTransition>
              <OrderTracking />
            </PageTransition>
          }
        />

        {/* ADMIN */}

        <Route
          path="/admin/login"
          element={
            <PageTransition>
              <AdminLogin />
            </PageTransition>
          }
        />

        <Route
          path="/admin"
          element={
            <AdminRoute>
              <PageTransition>
                <AdminDashboard />
              </PageTransition>
            </AdminRoute>
          }
        />

        <Route
          path="/admin/orders"
          element={
            <PageTransition>
              <AdminOrders />
            </PageTransition>
          }
        />

        <Route
          path="/custom-order"
          element={
            <PageTransition>
              <CustomOrderPage />
            </PageTransition>
          }
        />

        {/* RECOMMENDATIONS */}

        <Route
          path="/recommendations"
          element={
            <PageTransition>
              <Recommendations />
            </PageTransition>
          }
        />

      </Routes>

    </AnimatePresence>

  );

}

/* ===============================
   APP
=============================== */

function App() {

  const [darkMode,
    setDarkMode] =
    useState(false);

  const [loading,
    setLoading] =
    useState(true);

  useEffect(() => {

    const timer =
      setTimeout(() => {

        setLoading(false);

      }, 2200);

    return () =>
      clearTimeout(timer);

  }, []);

  return (

    <HelmetProvider>

      <AuthModalProvider>

        <AuthProvider>

          <CartProvider>

            <WishlistProvider>

              <Router>

                {/* MODALS */}

                <AuthModal />

                <LuxuryLoader
                  loading={loading}
                />

                {/* WRAPPER */}

                <div className={`
                  ${
                    darkMode

                      ? `
                        dark
                        bg-gray-900
                        text-white
                      `

                      : `
                        bg-[#FDFCFB]
                        text-stone-900
                      `
                  }

                  min-h-screen
                  flex
                  flex-col
                `}>

                  {/* NAVBAR */}

                  <Navbar
                    darkMode={darkMode}
                    setDarkMode={setDarkMode}
                  />

                  {/* MAIN */}

                  <main className="flex-1">

                    <Suspense

                      fallback={

                        <div className="
                          h-screen
                          flex
                          items-center
                          justify-center

                          text-stone-400
                          font-serif
                          italic
                        ">

                          Loading experience...

                        </div>

                      }
                    >

                      <AnimatedRoutes />

                    </Suspense>

                  </main>

                  {/* FOOTER */}

                  <Footer />

                  {/* FLOATING */}

                  <MobileBottomNav />

                  <WhatsAppButton />

                  <SalesPopup />

                </div>

              </Router>

            </WishlistProvider>

          </CartProvider>

        </AuthProvider>

      </AuthModalProvider>

    </HelmetProvider>

  );

}

export default App;